import { Routes } from "@angular/router";
import { HomeComponent } from "./home.component";
import { SeoStaticPageComponent } from "./seo-static-page.component";

export const routes: Routes = [
  { path: "", component: HomeComponent },
  {
    path: "como-criar-link-whatsapp",
    component: SeoStaticPageComponent,
    data: { slug: "como" },
  },
  {
    path: "link-whatsapp-com-mensagem",
    component: SeoStaticPageComponent,
    data: { slug: "mensagem" },
  },
  {
    path: "gerador-link-whatsapp-gratis",
    component: SeoStaticPageComponent,
    data: { slug: "gerador" },
  },
  { path: "how-to-create-whatsapp-link", component: SeoStaticPageComponent, data: { slug: "como-en" } },
  { path: "whatsapp-link-with-message", component: SeoStaticPageComponent, data: { slug: "message-en" } },
  { path: "free-whatsapp-link-generator", component: SeoStaticPageComponent, data: { slug: "generator-en" } },
  { path: "como-crear-enlace-whatsapp", component: SeoStaticPageComponent, data: { slug: "como-es" } },
  { path: "enlace-whatsapp-con-mensaje", component: SeoStaticPageComponent, data: { slug: "mensaje-es" } },
  { path: "generador-enlace-whatsapp-gratis", component: SeoStaticPageComponent, data: { slug: "generador-es" } },
  { path: "**", redirectTo: "" },
];
